import React from "react";
import { Button } from "./ui/button";
import { ChevronLeft } from "lucide-react";

interface LayoutProps {
  children: React.ReactNode;
  showBackButton?: boolean;
  onBack?: () => void;
  title?: string;
  className?: string;
}

export function Layout({
  children,
  showBackButton = false,
  onBack,
  title,
  className = "",
}: LayoutProps) {
  return (
    <div className="min-h-screen bg-app-background text-app-text">
      <div className="relative min-h-screen flex flex-col p-4">
        <header>
          {/* Back button */}
          {showBackButton && onBack && (
            <Button
              variant="ghost"
              size="icon"
              className="absolute top-4 left-4 h-10 w-10 rounded-full bg-app-card shadow-sm text-app-text hover:bg-app-card hover:opacity-80"
              aria-label="Back"
              onClick={onBack}
            >
              <ChevronLeft className="h-6 w-6" />
            </Button>
          )}

          {/* Title */}
          {title && (
            <div className="absolute top-4 left-1/2 transform -translate-x-1/2">
              <h1 className="text-lg font-semibold text-app-text">{title}</h1>
            </div>
          )}
        </header>

        {/* Main content */}
        <div
          className={`w-full max-w-md flex-1 ${showBackButton || title ? "pt-16" : ""} ${className}`}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
